<template>
    <div id="lineEdit">
        <steps :active="step - 1" :stepItems="stepItems" />
        <!-- 基础信息 -->
        <div v-show="step == 1">
            <el-card>
                <el-form :model="form" size="medium" :rules="rules" ref="line" label-width="80px" label-position="left"
                    style="width: 420px; margin: 0 auto;">
                    <el-form-item label="机构名称" prop="organizationId">
                        <el-select v-model="form.organizationId" placeholder="请选择机构名称" filterable>
                            <el-option v-for="item in organizations" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="线路起点" prop="startStationName">
                        <el-input v-model="form.startStationName" placeholder="请输入出发地" :maxlength="20"
                            show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="线路终点" prop="endStationName">
                        <el-input v-model="form.endStationName" placeholder="请输入目的地" :maxlength="20"
                            show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label=" ">
                        <el-button type="primary" @click="goStep(2, 'next')">下一步</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <!-- 站点信息 -->
        <div v-show="step == 2">
            <el-card>
                <div class="station-box">
                    <div class="flex-between">
                        <h3 class="station-title">上车站点</h3>
                        <div class="station-total">共{{ form.stationVoList[0].stationRail.length }}个站点</div>
                    </div>
                    <ul class="station-list">
                        <li class="station-item" v-for="(item, index) in form.stationVoList[0].stationRail"
                            :key="index">
                            <div class="station-name">{{ item.stationName }}</div>
                            <div class="station-action">
                                <span class="station-type"
                                    :class="item.stationType == 1 ? 'station-type-fixed' : 'station-type-range'">{{
                                        item.stationType == 1 ? '定点接送' : '上门接送' }}</span>
                                <div>
                                    <!-- 删除icon -->
                                    <i class="el-icon-delete" @click.stop="deleteStartPlaces(index)"></i>
                                    <i class="el-icon-edit-outline" @click.stop="clickStartItem(item, index)"></i>
                                </div>
                            </div>
                        </li>

                        <li class="station-add" @click="createdStartItem">
                            <el-button type="text" icon="el-icon-plus">添加上车站点</el-button>
                        </li>
                    </ul>
                </div>
                <div class="station-box" style="margin-top: 40px;">
                    <div class="flex-between">
                        <h3 class="station-title">下车站点</h3>
                        <div class="station-total">共{{ form.stationVoList[1].stationRail.length }}个站点</div>
                    </div>
                    <ul class="station-list">
                        <li class="station-item" v-for="(item, index) in form.stationVoList[1].stationRail"
                            :key="index">
                            <div class="station-name">{{ item.stationName }}</div>
                            <div class="station-action">
                                <span class="station-type"
                                    :class="item.stationType == 1 ? 'station-type-fixed' : 'station-type-range'">{{
                                        item.stationType == 1 ? '定点接送' : '上门接送' }}</span>
                                <div>
                                    <!-- 删除icon -->
                                    <i class="el-icon-delete" @click.stop="deleteEndPlaces(index)"></i>
                                    <i class="el-icon-edit-outline" @click.stop="clickEndItem(item, index)"></i>
                                </div>
                            </div>
                        </li>

                        <li class="station-add" @click="createdEndItem">
                            <el-button type="text" icon="el-icon-plus">添加下车站点</el-button>
                        </li>
                    </ul>
                </div>

                <div style="margin-top: 40px;">
                    <el-button size="medium" type="" @click="goStep(1, 'prev')">上一步</el-button>
                    <el-button size="medium" type="primary" @click="goStep(3, 'next')">下一步</el-button>
                </div>
            </el-card>
        </div>
        <!-- 车型配置 -->
        <div v-show="step == 3">
            <el-card>
                <div class="vehicleType">
                    <div class="label">运营车型</div>
                    <div class="vehicle-list">
                        <div class="vehicle-item" v-for="item in vehicleTypeList" :key="item"
                            :class="{ active: vehicleType.includes(item) }" @click="toggleVehicleType(item)">
                            {{ item }}座车
                        </div>
                    </div>
                    <div class="label" style="margin-top: 20px;">价格提成</div>
                    <el-form ref="priceForm" label-width="0">
                        <div class="price-config">
                            <table class="price-table">
                                <thead>
                                    <tr>
                                        <th>车辆座位数</th>
                                        <th>车型价格</th>
                                        <th>司机提成</th>
                                        <th>承运车型(非必填)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in vehicleTypeData" :key="item.vehicleSeat">
                                        <td>{{ item.vehicleSeat }}座车</td>
                                        <td>
                                            <el-form-item :prop="'fee_' + item.vehicleSeat">
                                                <el-input v-model="item.fee" placeholder="请输入"
                                                    v-input-filter="{ min: 1, max: 999999, precision: 0 }">
                                                    <template #append>元</template>
                                                </el-input>
                                            </el-form-item>
                                        </td>
                                        <td>
                                            <el-form-item :prop="'commission_' + item.vehicleSeat">
                                                <div class="commission-input">
                                                    <!-- <el-select v-model="item.driverCommissionType" placeholder="请选择"
                                                        @change="handleCommissionTypeChange(item)"
                                                        style="width: 120px;">
                                                        <el-option label="固定提成" :value="1"></el-option>
                                                        <el-option label="比例提成" :value="2"></el-option>
                                                    </el-select> -->
                                                    <el-input v-model="item.driverCommission" placeholder="请输入"
                                                        :v-input-filter="{ min: 1, max: 999999, precision: 0 }">
                                                        <template #append>元</template>
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                        </td>
                                        <td>
                                            <el-form-item :prop="'model_' + item.vehicleSeat">
                                                <el-input v-model="item.vehicleModel" placeholder="例如：比亚迪秦PLUS" :maxlength="50">
                                                </el-input>
                                            </el-form-item>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-form>
                    <div class="form-actions" style="margin-top: 20px;">
                        <el-button size="medium" @click="goStep(2, 'prev')">上一步</el-button>
                        <el-button size="medium" type="primary" @click="save" :loading="saveLoading">保存</el-button>
                    </div>
                </div>
            </el-card>

        </div>

        <el-dialog title="站点信息" :visible.sync="stationEditDialog" width="800px" :before-close="closeStationEditDialog"
            :destroy-on-close="true" :close-on-click-modal="false">
            <div class="station-type-tabs">
                <div class="tab-item"
                    :class="{ active: form.stationVoList?.[active.place]?.stationRail?.[active.index]?.stationType == 1 }"
                    @click="actionTypeChange(1, active.place, form.stationVoList?.[active.place]?.stationRail?.[active.index], active.index)">
                    <div class="tab-title">定点接送</div>
                    <div class="tab-desc">乘客仅可在指定站点上下车</div>
                </div>
                <div class="tab-item"
                    :class="{ active: form.stationVoList?.[active.place]?.stationRail?.[active.index]?.stationType == 2 }"
                    @click="actionTypeChange(2, active.place, form.stationVoList?.[active.place]?.stationRail?.[active.index], active.index)">
                    <div class="tab-title">上门接送</div>
                    <div class="tab-desc">乘客可在电子围栏内任意位置上下车</div>
                </div>
            </div>
            <div class="right">
                <div class="map-search">
                    <choose-address :value.sync="searchText" placeholder="在地图上搜索位置" :citycode="cityAdcode"
                        @clickRowFn="clickPoint" style="width: 200px"></choose-address>
                </div>
                <div class="map-buttons" v-if="targetPlace.stationType == 2">
                    <div @click="clickHollow">挖空当前围栏</div>
                    <div @click="emptyPolygon">重新绘制围栏</div>
                </div>
                <div id="mapCtx"></div>
            </div>
            <el-form label-width="80px" ref="mapForm" :model="targetPlace" :rules="{
                stationName: [
                    { required: true, message: '请输入站点名称', trigger: ['blur', 'change'] },
                ],
            }">
                <el-form-item label="站点名称" prop="stationName">
                    <el-input size="medium" v-model="targetPlace.stationName" placeholder="请输入站点名称" :maxlength="20"
                        show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveStation">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 是否创建返程线路弹窗 -->
        <el-dialog title="是否创建返程线路" :visible.sync="returnLineDialog" width="450px" :destroy-on-close="true"
            :close-on-click-modal="false">
            <div class="return-content">
                <div class="return-content-item" @click="isReturn(1)">
                    <div class="return-content-item-title">需创建返程线路</div>
                    <div class="return-content-item-desc">创建当前线路的同时，也创建一条对应的返程线路</div>
                </div>
                <div class="return-content-item" @click="isReturn(2)">
                    <div class="return-content-item-title">仅创建单程线路</div>
                    <div class="return-content-item-desc">仅先创建当前线路，需返程时再单独建返程线路</div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import AMap from "AMap";
import polygonClipping from "polygon-clipping";
import isPolygonsOverlap from "@/assets/js/polygon";
import steps from '../components/steps.vue';
export default {
    name: "lineEdit",
    components: {
        steps
    },
    data() {
        return {
            id: this.$route.query.id || null,
            stepItems: ['1.基础信息', '2.站点信息', '3.车型配置'],
            step: 1,
            form: {
                organizationId: '',
                startStationName: '',
                endStationName: '',
                stationVoList: [
                    // 保存地址的经纬度和名称
                    {
                        stationRail: [],
                    },
                    {
                        stationRail: [],
                    },
                ],
            },
            rules: {
                organizationId: [{ required: true, message: '请选择机构名称', trigger: ['blur', 'change'] }],
                startStationName: [{ required: true, message: '请输入出发地', trigger: ['blur', 'change'] }],
                endStationName: [{ required: true, message: '请输入目的地', trigger: ['blur', 'change'] }],
            },
            // 当前操作的 地址类型：0起点 1终点、地址下标、地图绘制类型
            active: {
                place: 0,
                index: 0,
                actionType: "site", // 站点site ||  绘制draw || 挖空hollow
            },
            // 地图上下文
            mapCtx: null,
            searchText: '',
            // 鼠标工具
            mouseTool: null,
            polygonColor: {
                startBKGD: "#deefff",
                startBKGDFC: "#0288FF",
                startBD: "#a0d1ff",
                startBDFC: "#68b6ff",
                endBKGD: "#deffe7",
                endBKGDFC: "#40ff02",
                endBD: "#228b2252",
                endBDFC: "#228b2236",
            },
            // 地图当前城市,用于搜索
            cityAdcode: null,
            vehicleType: [5, 7],
            vehicleTypeList: [5, 7, 8, 9],
            vehicleTypeData: [],
            priceRules: {
                fee: [
                    { required: true, message: '请输入车型价格', trigger: 'blur' },
                    { type: 'number', message: '车型价格必须为数字' },
                    {
                        validator: (rule, value, callback) => {
                            if (value < 1 || value > 999999 || !Number.isInteger(value)) {
                                callback(new Error('请输入1-999999的整数'));
                            } else {
                                callback();
                            }
                        }, trigger: 'blur'
                    }
                ],
                driverCommission: [
                    { required: true, message: '请输入司机提成', trigger: 'blur' },
                    { type: 'number', message: '提成必须为数字' },
                    {
                        validator: (rule, value, callback) => {
                            if (value < 1 || !Number.isInteger(value)) {
                                callback(new Error('请输入大于1的整数'));
                            } else {
                                callback();
                            }
                        }, trigger: 'blur'
                    }
                ]
            },
            saveLoading: false,
            stationEditDialog: false,
            isAdd: true,
            oldItem: {},
            returnLineDialog: false,
        };
    },
    computed: {
        // 当前操作的目标地址对象getInfoOverlay
        targetPlace() {
            return this.form.stationVoList?.[this.active.place]?.stationRail?.[this.active.index] || {};
        },
    },
    watch: {
        vehicleType: {
            handler(val) {
                let newVal = [...val];
                this.vehicleTypeData = newVal.sort((a, b) => a - b).map(item => {
                    let vehiclePrice = this.vehicleTypeData.find(vitem => vitem.vehicleSeat == item);
                    if (vehiclePrice) {
                        return { ...vehiclePrice };
                    } else {
                        return { vehicleSeat: item, driverCommissionType: 1, driverCommission: "", vehicleModel: "" };
                    }
                });
            },
            immediate: true,
        },
    },

    async mounted() {
        this.getInfo();
        await this.mixinOrganizations();
        if (!this.id && this.mixinUserInfo?.organizationType === 2 && this.organizations?.[0]?.id) {
            this.$set(this.form, "organizationId", this.organizations[0].id);
        }
    },
    methods: {
        goStep(step, type) {
            if (step == 1) {
                this.step = step;
            } else if (step == 2) {
                if (type == 'next') {
                    this.$refs.line.validate(async (valid) => {
                        if (valid) {
                            let { data, code } = await this.$axios.get("/api/v1/manage/travelLine/checkLineName", {
                                startStationName: this.form.startStationName,
                                endStationName: this.form.endStationName,
                                id: this.id,
                            });
                            if (code == 1 && data) {
                                this.$message.error("存在相同名称的文旅线路");
                                return;
                            }
                            this.step = step;
                        } else {
                            return false;
                        }
                    });
                } else {
                    this.step = step;
                }
            } else if (step == 3) {
                if (this.form.stationVoList[0].stationRail.length == 0) {
                    this.$message.warning('请添加上车站点')
                    return
                }
                if (this.form.stationVoList[1].stationRail.length == 0) {
                    this.$message.warning('请添加下车站点')
                    return
                }

                this.step = step;
            }
        },

        /* 初始化地图 */
        initMap() {
            this.mapCtx = new AMap.Map("mapCtx", {
                mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
                resizeEnable: true,
                zoom: 14,
                doubleClickZoom: false,
                center: new AMap.LngLat(104.065861, 30.657401),
            });

            this.cityAdcode = this.mapCtx.getAdcode();

            // 初始化鼠标工具
            this.mouseTool = new AMap.MouseTool(this.mapCtx);

            // 鼠标绘制完毕事件
            this.mouseTool.on("draw", (e) => {
                this.mouseTool.close(true);
                // obj对象为绘制出来的覆盖物对象。
                this.mapCtx.remove(e.obj);

                // 绘制结果为多边形时
                if (e.obj.CLASS_NAME === "AMap.Polygon") {
                    let corners = Array.from(e.obj.getPath(), (value) => [
                        value.lng,
                        value.lat,
                    ]);

                    this.handleDraw(corners);
                }
            });

            // 鼠标双击事件
            this.mapCtx.on("dblclick", async (e) => {
                if (this.active.actionType == "site") {
                    // 若动作类型为站点 > 则绘制图标
                    this.handleDouble(e.lnglat);
                }
            });

            this.placeChange();
        },
        /* 创建一个起点 */
        createdStartItem() {
            this.stationEditDialog = true;
            this.isAdd = true;
            this.form.stationVoList[0].stationRail.push({
                type: 1,
                stationType: 1,
                stationName: null,
                marker: null,
                polygon: null,
            });
            this.active = {
                place: 0,
                index: this.form.stationVoList[0].stationRail.length - 1,
                actionType: "site",
            };
            this.$nextTick(() => {
                this.initMap();
            });
        },
        /* 创建一个终点 */
        createdEndItem() {
            this.stationEditDialog = true;
            this.isAdd = true;
            this.form.stationVoList[1].stationRail.push({
                type: 2,
                stationType: 1,
                stationName: null,
                marker: null,
                polygon: null,
            });
            this.active = {
                place: 1,
                index: this.form.stationVoList[1].stationRail.length - 1,
                actionType: "site",
            };
            this.$nextTick(() => {
                this.initMap();
            });

        },
        /**
         * 点击一个起点
         * @item   起点地址对象
         * @index  起点地址下标
         * @action 是否启动鼠标绘画事件
         */
        clickStartItem(item, index) {
            this.stationEditDialog = true;
            this.isAdd = false;
            this.oldItem = { ...item }
            this.active = {
                place: 0,
                index,
                actionType: item.stationType == 1 ? "site" : "draw",
            };
            this.$nextTick(() => {
                this.initMap();
            });
        },
        /* 点击一个终点 */
        clickEndItem(item, index) {
            this.stationEditDialog = true;
            this.isAdd = false;
            this.oldItem = { ...item }
            this.active = {
                place: 1,
                index,
                actionType: item.stationType == 1 ? "site" : "draw",
            };
            this.$nextTick(() => {
                this.initMap();
            });
        },
        /**
        * 绘制类型变化
        * @actionType 点击站点类型
        * @place      0 起点  1 终点
        * @item       地址    可选
        * @index      下标    可选
        */
        actionTypeChange(actionType, place, item, index) {
            this.targetPlace.stationName = ''
            if (item) {
                this.active = {
                    place: place || this.active.place,
                    index,
                    actionType: new Map([
                        [1, "site"],
                        [2, "draw"],
                        [3, "hollow"],
                    ]).get(actionType),
                };
            } else if (actionType) {
                this.active = {
                    place: place || this.active.place,
                    index: this.active.index,
                    actionType: new Map([
                        [1, "site"],
                        [2, "draw"],
                        [3, "hollow"],
                    ]).get(actionType),
                };
            }
            if (this.active.actionType == "site") {
                // 若目标地址绘制类型为站点

                if (this.targetPlace?.polygon) {
                    // 若之前目标地址已有围栏 > 则删除围栏数据
                    this.mapCtx.remove(this.targetPlace.polygon);
                    this.targetPlace.polygon = null;
                    this.form.stationVoList[this.active.place].stationRail[this.active.index].enclosureAddress = null;
                    this.form.stationVoList[this.active.place].stationRail[this.active.index].polygon = null;

                }
            } else if (this.active.actionType == "draw") {
                if (this.targetPlace?.marker) {
                    // 若之前目标地址已有marker > 则删除marker数据
                    this.mapCtx.remove(this.targetPlace.marker);
                    this.targetPlace.marker = null;
                }

                // 若目标地址绘制类型为围栏(多边形)
                if (!this.targetPlace?.polygon) {
                    // 且不存在围栏
                    if (this.active.place == 0) {
                        this.mouseTool.polygon({
                            fillOpacity: 0.3,
                            fillColor: this.polygonColor.startBKGDFC,
                            strokeColor: this.polygonColor.startBDFC,
                        });
                    } else {
                        this.mouseTool.polygon({
                            fillOpacity: 0.3,
                            fillColor: this.polygonColor.endBKGDFC,
                            strokeColor: this.polygonColor.endBDFC,
                        });
                    }
                }
            } else if (this.active.actionType == "hollow") {
                // 若目标地址绘制类型为挖空(多边形)
                this.mouseTool.polygon({
                    fillColor: "gainsboro",
                    strokeColor: "#fffffff0",
                });
            }
            if (actionType) {
                this.form.stationVoList[this.active.place].stationRail[this.active.index].stationType = actionType;
            }

        },

        saveStation() {
            this.$refs.mapForm.validate(async (valid) => {
                if (valid) {
                    if (!this.targetPlace.marker && !this.targetPlace.polygon) {
                        this.$message.error("请先绘制站点或围栏");
                        return;
                    }
                    if (!this.targetPlace.stationName) {
                        this.$message.error("请先输入站点名称");
                        return;
                    }
                    this.form.stationVoList[this.active.place].stationRail[this.active.index] = this.targetPlace;
                    this.stationEditDialog = false;
                }
            })
        },

        closeStationEditDialog() {
            if (this.isAdd) {
                this.form.stationVoList[this.active.place].stationRail.pop();
            } else {
                this.form.stationVoList[this.active.place].stationRail[this.active.index] = this.oldItem;
            }
            this.stationEditDialog = false;
        },

        /* 聚焦目标地址变化，覆盖物重新渲染 */
        placeChange() {
            let item = this.form.stationVoList[this.active.place].stationRail[this.active.index];
            if (item.stationType == 1 && item.longitude && item.latitude) {
                this.formAddMarker(new AMap.LngLat(item.longitude, item.latitude), item.stationName);
            } else if (item.stationType == 2 && item.enclosureAddress) {
                this.formAddPolygon(JSON.parse(item.enclosureAddress));
            }


            if (this.targetPlace?.stationType == 1) {
                // 若当前地址类型为定点接送 > 则关闭鼠标绘制
                this.mouseTool.close(true);
            } else if (!this.targetPlace?.polygon) {
                this.actionTypeChange();
            }
        },

        /**
         * 原始经纬度生成站点(Marker)
         * @position  经纬度对象
         * @label     Marker标签文字
         */
        structureMarker(position, label) {
            let content = `<div class="markerLabel ${this.active.place == 0 ? "startFC" : "endFC"}">${label}</div>`;
            let Mark = new AMap.Marker({
                map: this.mapCtx, // 地图实例对象
                position: position, // 标记位置
                // anchor: "bottom-center", // 设置锚点方位
                animation: "AMAP_ANIMATION_DROP", // 标记掉落效果
                icon:
                    this.active.place == 0
                        ? require("@/assets/img/markerBegin.png")
                        : require("@/assets/img/markerEnd.png"),
                offset: new AMap.Pixel(-2, 0),
            });
            Mark.setLabel({
                content: content,
                direction: "top",
                offset: new AMap.Pixel(0, -6),
            });
            this.mapCtx.setFitView(
                Mark,
                true,
                [200, 200, 200, 200],
                15
            );

            return Mark;
        },
        /**
         * 绘制marker点覆盖物 => form添加站点(Marker)
         * @lnglat       经纬度
         * @stationName  准确地点名称
         */
        formAddMarker(lnglat, stationName) {
            // 生成Marker
            let marker = this.structureMarker(lnglat, stationName);

            if (this.targetPlace.marker) {
                this.mapCtx.remove(this.targetPlace.marker);
                this.targetPlace.marker = null;
            }

            // 添加站点(Marker)
            this.targetPlace.marker = marker;
        },
        /**
        * 处理双击的回调站点
        * @lnglat 点击位置的经纬度
        */
        async handleDouble(lnglat) {
            let resCity = await this.$AMap.AMapReGeo(lnglat);

            if (resCity) {
                let pois = resCity.regeocode.pois;
                pois.sort((a, b) => {
                    return a.distance - b.distance;
                });
                let addressComponent = resCity.regeocode.addressComponent;
                let stationName = pois?.[0]?.name || resCity.regeocode.formatted_address;
                this.targetPlace.stationName = stationName;
                this.targetPlace.stationAddress = pois?.[0]?.address || resCity.regeocode.formatted_address;
                this.targetPlace.province = addressComponent.province;
                this.targetPlace.city = addressComponent.city;
                this.targetPlace.area = addressComponent.district;
                this.targetPlace.cityCode = addressComponent.citycode;
                this.targetPlace.adCode = addressComponent.adcode;
                this.targetPlace.longitude = lnglat.lng;
                this.targetPlace.latitude = lnglat.lat;
                this.formAddMarker(lnglat, stationName);
            }
        },

        /**
         * 处理绘制的多边形
         * @corners   多边形原始角数据
         */
        handleDraw(corners) {
            // 判断这个围栏是否规范,长度大于1说明生成了一个以上的围栏,同时difference函数会补全封闭角,千万别动这行
            corners = polygonClipping.difference([corners]);

            if (corners.length > 1) {
                this.$message.warning("围栏线条禁止相交，请重新绘制");
                this.actionTypeChange();
                return;
            }

            if (this.active.actionType === "draw") {
                this.formAddPolygon(corners);
                this.formAddCityData(corners);
            } else if (this.active.actionType === "hollow") {
                // 原围栏角数据
                let base = this.targetPlace.polygon.getPath();

                // 合并已建设围栏(多边形)的角数据和挖空多边形的角数据，生成新的的角数据
                corners = this.mergeHollow(base, corners);

                this.mapCtx.remove(this.targetPlace.polygon);
                this.targetPlace.polygon = null;
                this.form.stationVoList[this.active.place].stationRail[this.active.index].enclosureAddress = null;
                this.form.stationVoList[this.active.place].stationRail[this.active.index].polygon = null;
                this.formAddPolygon(corners);
            }

            this.placeChange();
        },

        /**
         * 处理绘制的多边形 => form添加围栏(多边形)
         * @corners   多边形原始角数据
         */
        formAddPolygon(corners) {
            // 生成并添加围栏
            this.targetPlace.polygon = this.structurePolygon(corners);
        },

        /**
         * 处理绘制的多边形 => form添加围栏(多边形)的城市信息数据
         * @corners   多边形原始角数据
         * @city      城市数据
         */
        async formAddCityData(corners, resCity = null) {
            if (corners.length > 0) {
                let arr = [];
                if (!Array.isArray(corners[0])) {
                    arr = corners[0];
                } else {
                    arr = corners[0][0][0];
                }

                let regeo = await this.$AMap.AMapReGeo(arr);
                resCity = regeo.regeocode.addressComponent;

                if (resCity) {
                    this.targetPlace.enclosureAddress =
                        corners.length > 0 ? JSON.stringify(corners) : "";
                    this.targetPlace.province = resCity.province || "";
                    this.targetPlace.city = resCity.city || "";
                    this.targetPlace.area = resCity.area || "";
                    this.targetPlace.cityCode = resCity.citycode || "";
                    this.targetPlace.adCode = resCity.adcode || "";
                }
            }
        },
        /**
         * 原始角数据生成围栏(多边形)
         * @corners   多边形原始角数据
         */
        structurePolygon(corners) {

            let polygon = new AMap.Polygon({
                map: this.mapCtx,
                path: corners,
                fillOpacity: 0.5,
                strokeOpacity: 1,
                fillColor:
                    this.active.place == 0
                        ? this.polygonColor.startBKGD
                        : this.polygonColor.endBKGD,
                strokeColor:
                    this.active.place == 0
                        ? this.polygonColor.startBDFC
                        : this.polygonColor.endBDFC,
            });
            this.mapCtx.setFitView(
                polygon,
                // true,
                // [200, 200, 200, 200],
                // 14
            );
            return polygon;
        },

        /* 地图搜索-选择地点 */
        async clickPoint(res) {
            let resCity = await this.$AMap.AMapReGeo(res.location);
            if (this.targetPlace?.stationType == 1) {
                if (resCity) {
                    let pois = resCity.regeocode.pois;
                    pois.sort((a, b) => {
                        return a.distance - b.distance;
                    });

                    let addressComponent = resCity.regeocode.addressComponent;
                    this.targetPlace.province = addressComponent.province;
                    this.targetPlace.city = addressComponent.city;
                    this.targetPlace.area = addressComponent.district;
                    this.targetPlace.cityCode = addressComponent.citycode;
                    this.targetPlace.adCode = addressComponent.adcode;
                }
                this.targetPlace.stationName = res.name;
                this.targetPlace.stationAddress = res.district;
                this.targetPlace.longitude = res.location.lng;
                this.targetPlace.latitude = res.location.lat;
                this.formAddMarker(res.location, res.name);
                this.searchText = "";
                this.mapCtx.setFitView(
                    this.targetPlace.marker,
                    true,
                    [200, 200, 200, 200],
                    15
                );
            } else {
                this.mapCtx.panTo(res.location);
            }
        },
        /**
         * 挖空角数据处理
         * @base      已建设围栏的原始角数据
         * @hollow    挖空多边形的原始角数据
         */
        mergeHollow(base, hollow) {
            let res = null;
            if (
                base[0] &&
                Array.isArray(base[0]) &&
                base[0][0] &&
                Array.isArray(base[0][0]) &&
                base.length > 1
            ) {
                /* 被挖断的围栏处理 */
                let all = [];
                for (let i = 0; i < base.length; i++) {
                    let allRes = this.baseData(base[i], []);
                    if (isPolygonsOverlap(hollow, allRes)) {
                        allRes.push(hollow[0][0]);
                        res = polygonClipping.difference(allRes);
                    }
                    all = [...all, ...res];
                }
                this.formAddCityData(all);
                return all;
            } else {
                /* 一般围栏处理 */
                let allRes = this.baseData(base);
                allRes.push(hollow[0][0]);
                res = polygonClipping.difference(allRes);
                this.formAddCityData(res);
                return res;
            }
        },

        /* 复杂围栏处理,比如一个围栏被挖断 */
        baseData(data, list = []) {
            if (!Array.isArray(data[0])) {
                let lnglat = data.map((val) => [val.lng, val.lat]);
                list.push(lnglat);
            } else {
                for (let i = 0; i < data.length; i++) {
                    this.baseData(data[i], list);
                }
            }
            return list;
        },

        /* 删除一个起点 */
        deleteStartPlaces(index) {
            this.$confirm('确定要删除该站点吗？', '删除', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.form.stationVoList[0].stationRail.splice(index, 1);
                this.active.index = null;
            })
        },

        /* 删除一个终点 */
        deleteEndPlaces(index) {
            this.$confirm('确定要删除该站点吗？', '删除').then(() => {
                this.form.stationVoList[1].stationRail.splice(index, 1);
                this.active.index = null;
            })
        },

        /* 清空围栏数据 */
        emptyPolygon() {
            if (!this.targetPlace.polygon) {
                this.$message.info("该地点未设置围栏");
                return;
            }
            this.$confirm(`确定要清空该围栏？`, "提示").then(() => {
                this.mapCtx.remove(this.targetPlace.polygon);
                this.targetPlace.polygon = null;
                this.form.stationVoList[this.active.place].stationRail[this.active.index].enclosureAddress = null;
                this.form.stationVoList[this.active.place].stationRail[this.active.index].polygon = null;
                this.active = {
                    place: this.active.place,
                    index: this.active.index,
                    actionType: 'draw'
                };
                this.actionTypeChange();
            });
        },

        /* 点击挖空 */
        clickHollow() {
            if (this.targetPlace.polygon) {
                this.active = {
                    place: this.active.place,
                    index: this.active.index,
                    actionType: 'hollow'
                };
                this.mouseTool.polygon({
                    fillColor: "gainsboro",
                    strokeColor: "#fffffff0",
                });
            } else {
                this.$message.info("该地址没有围栏");
            }
        },
        /* 获取线路详情 */
        async getInfo() {
            if (!this.id) {
                return false;
            }
            let url = "/api/v1/manage/travelLine/" + this.id;
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                let startStationList = data.travelStations.filter(item => item.type === 1);
                let endStationList = data.travelStations.filter(item => item.type === 2);
                this.form = {
                    organizationId: data.organizationId,
                    startStationName: data.startStationName,
                    endStationName: data.endStationName,
                    stationVoList: [
                        {
                            stationRail: startStationList
                        },
                        {
                            stationRail: endStationList
                        }
                    ],
                };
                this.vehicleType = data.vehicleModelSeat.split(',').map(item => parseInt(item));
                this.vehicleTypeData = data.lineFees;
            }
        },

        async save() {
            if (this.vehicleTypeData.length === 0) {
                this.$message.error('请选择车型');
                return;
            }

            // 直接验证vehicleTypeData
            let isValid = true;
            for (let item of this.vehicleTypeData) {
                // 验证车型价格
                if (!item.fee) {
                    this.$message.error('请输入车型价格');
                    isValid = false;
                    break;
                }
                if (item.fee < 1 || item.fee > 999999 || !Number.isInteger(Number(item.fee))) {
                    this.$message.error('车型价格必须是1-999999的整数');
                    isValid = false;
                    break;
                }

                // 验证司机提成
                if (!item.driverCommission) {
                    this.$message.error('请输入司机提成');
                    isValid = false;
                    break;
                }
                if (item.driverCommissionType === 1) {
                    // 固定提成
                    if (item.driverCommission < 1 || item.driverCommission > 999999 || !Number.isInteger(Number(item.driverCommission))) {
                        this.$message.error('固定提成必须是1-999999的整数');
                        isValid = false;
                        break;
                    }
                } else {
                    // 比例提成
                    if (item.driverCommission < 1 || item.driverCommission > 100 || !Number.isInteger(Number(item.driverCommission))) {
                        this.$message.error('比例提成必须是1-100的整数');
                        isValid = false;
                        break;
                    }
                }
            }

            if (!isValid) {
                return;
            }
            let { data, code } = await this.$axios.get("/api/v1/manage/travelLine/checkLineName", {
                startStationName: this.form.startStationName,
                endStationName: this.form.endStationName,
                id: this.id,
            });
            if (code == 1 && data) {
                this.$message.error("存在相同名称的文旅线路");
                return;
            }
            if (this.id) {
                this.isReturn();
            } else {
                this.returnLineDialog = true;
            }
        },
        isReturn(type) {
            // 验证通过，继续保存操作
            this.form.stationVoList[0].stationRail.forEach(item => {
                delete item.marker;
                delete item.polygon;
            });
            this.form.stationVoList[1].stationRail.forEach(item => {
                delete item.marker;
                delete item.polygon;
            });
            let params = {
                organizationId: this.form.organizationId,
                startStationName: this.form.startStationName,
                endStationName: this.form.endStationName,
                travelStations: JSON.stringify([...this.form.stationVoList[0].stationRail, ...this.form.stationVoList[1].stationRail]),
                lineFees: JSON.stringify(this.vehicleTypeData),
                vehicleModelSeat: this.vehicleType.join(','),
                id: this.id || null,
                isReturn: type
            }
            let url = "/api/v1/manage/travelLine"
            if (!this.id) {
                this.postFn(url, params);
            } else {
                this.putFn(url, params);
            }
        },
        postFn(url, params) {
            this.saveLoading = true;
            this.$axios.post(url, params).then(res => {
                if (res.code === 1) {
                    this.$message.success('保存成功');
                    this.$router.go(-1);
                }
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        putFn(url, params) {
            this.saveLoading = true;
            this.$axios.put(url, params).then(res => {
                if (res.code === 1) {
                    this.$message.success('保存成功');
                    this.$router.go(-1);
                }
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        toggleVehicleType(item) {
            if (this.vehicleType.includes(item)) {
                this.vehicleType = this.vehicleType.filter(i => i !== item);
            } else {
                this.vehicleType.push(item);
            }
        },

    }
}
</script>

<style lang="less" scoped>
#lineEdit {
    height: 100%;
    box-sizing: border-box;

    .card-header {
        margin-bottom: 16px;
    }

    // 第二步 站点列表
    .station-box {
        .station-title {
            margin-bottom: 16px;
        }

        .station-list {

            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 16px;


            .station-item {
                list-style: none;
                padding: 16px;
                width: 32%;
                height: 100px;
                border-radius: 8px;
                box-sizing: border-box;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                background: linear-gradient(180deg, #E1EDFF 0%, #F5F9FF 0%, #FFFFFF 100%);
                // background: linear-gradient( 180deg, #FAFCFF 0%, #FFFFFF 100%);
                // background: #fff;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
                border: none;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                &:hover {
                    transform: scale(1.02);
                    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.12);
                }

                .station-name {
                    font-size: 16px;
                    font-weight: 600;
                    margin-bottom: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .station-action {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .station-type {
                        padding: 4px;
                        border-radius: 4px;
                        font-size: 12px;
                    }

                    .station-type-fixed {
                        background-color: #DCFCE7;
                        color: #166534;
                        // border: 1px solid #166534;
                    }

                    .station-type-range {
                        background-color: #DBEAFE;
                        color: #1E40AF;
                        // border: 1px solid #1E40AF;
                    }

                    i {
                        font-size: 18px;
                        cursor: pointer;
                        margin-left: 10px;
                        transition: color 0.2s ease-in-out;

                        &:hover {
                            color: #409EFF;
                        }
                    }
                }
            }

            .station-add {
                width: 32%;
                height: 100px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                cursor: pointer;
                background-color: #fff;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
                border: none;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

                &:hover {
                    transform: scale(1.02);
                    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.12);
                }

                button {
                    font-size: 18px;
                }
            }
        }

        .station-total {
            font-size: 14px;
            color: #989898;
        }
    }

    // 地图
    .right {
        width: 100%;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 16px;

        #mapCtx {
            width: 100%;
            height: 410px;
        }

        /deep/ .markerLabel {
            padding: 1rem 1.5rem;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            font-size: 1.5rem;
            color: #ffffff;
            box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

            &.start {
                background-color: #0289ffbb;
            }

            &.startFC {
                background-color: #0289ff;
            }

            &.end {
                background-color: #228b22bb;
            }

            &.endFC {
                background-color: #228b22;
            }
        }

        .map-search {
            position: absolute;
            top: 10px;
            left: 10px;
            z-index: 1000;

            /deep/ input {
                height: 36px;
            }
        }

        .map-buttons {
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 1000;
            display: flex;
            align-items: center;

            div {
                background-color: #fff;
                border-radius: 4px;
                padding: 4px 10px;
                margin-left: 10px;
                text-align: center;
                border: 1px black solid;
                cursor: pointer;
                box-sizing: border-box;
            }
        }
    }


    .vehicleType {
        .label {
            width: 100px;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 16px;
        }

        .vehicle-list {
            display: flex;
            gap: 11px;
            flex-wrap: wrap;

            .vehicle-item {
                width: 24%;
                box-sizing: border-box;
                padding: 16px;
                border: 1px solid #DCDFE6;
                border-radius: 8px;
                cursor: pointer;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                background-color: #fff;
                position: relative;
                text-align: center;
                font-size: 16px;
                font-weight: 600;
                color: #303133;

                &:hover {
                    border-color: #409EFF;
                }

                &.active {
                    border: 1px solid #409EFF;
                    background-color: #fff;
                    color: #409EFF;

                    &::after {
                        content: "";
                        position: absolute;
                        top: -1px;
                        right: -1px;
                        width: 0;
                        height: 0;
                        border-style: solid;
                        border-width: 0 42px 42px 0;
                        border-color: transparent #409EFF transparent transparent;
                        border-top-right-radius: 8px;
                    }

                    &::before {
                        content: "\e6da";
                        font-family: element-icons !important;
                        position: absolute;
                        top: 4px;
                        right: 4px;
                        color: #fff;
                        font-size: 16px;
                        z-index: 1;
                    }
                }
            }
        }
    }

}

.station-type-tabs {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;

    .tab-item {
        flex: 1;
        padding: 8px;
        border: 1px solid #DCDFE6;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        background-color: #fff;
        position: relative;

        &:hover {
            border-color: #409EFF;
        }

        &.active {
            border: 1px solid #409EFF;
            background-color: #fff;

            &::after {
                content: "";
                position: absolute;
                top: -1px;
                right: -1px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 0 42px 42px 0;
                border-color: transparent #409EFF transparent transparent;
                border-top-right-radius: 8px;
            }

            &::before {
                content: "\e6da";
                font-family: element-icons !important;
                position: absolute;
                top: 4px;
                right: 4px;
                color: #fff;
                font-size: 16px;
                z-index: 1;
            }

            .tab-title {
                color: #409EFF;
            }
        }

        .tab-title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 4px;
            color: #303133;
            transition: color 0.3s;
        }

        .tab-desc {
            font-size: 14px;
            color: #909399;
            line-height: 1.4;
        }
    }
}

.price-config {
    .price-table {
        width: 100%;
        border-collapse: collapse;

        th {
            background-color: #F5F7FA;
            padding: 12px;
            text-align: left;
            font-weight: 600;
            color: #606266;
            border-bottom: 1px solid #EBEEF5;
        }

        td {
            padding: 12px;
            border-bottom: 1px solid #EBEEF5;
            vertical-align: middle;

            &:first-child {
                color: #303133;
                font-weight: 500;
                width: 100px;
            }

            &:nth-child(2) {
                width: 200px;
            }

            &:nth-child(3) {
                width: 320px;
            }

            &:nth-child(4) {
                width: 200px;
            }
        }

        .commission-input {
            display: flex;
            gap: 8px;
            align-items: center;

            .el-input {
                flex: 1;
            }
        }

        /deep/ .el-form-item {
            margin-bottom: 0;
        }

        /deep/ .el-input-group__append {
            padding: 0 12px;
        }

        /deep/ .el-input__inner {
            height: 32px;
            line-height: 32px;
        }

        /deep/ .el-input__icon {
            line-height: 32px;
        }
    }
}

.return-content {
    &-item {
        border: 1px solid #DCDFE6;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 16px;
        cursor: pointer;

        &-title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 16px;
        }

        &-desc {
            font-size: 14px;
            color: #909399;
            line-height: 1.4;
        }
    }
}
</style>